module.exports = __webpack_public_path__ + "static/default-avatar-e0536c4925e5d64a9d7074da93ec5388.png";